/*
 * @Author: linqiushu
 * @Date: 2021-06-15 17:20:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-23 15:05:51
 */
class common{
    isIdCard(idcardbody){
        if (!idcardbody || idcardbody.length!= 18) { return false;}
        var result=idcardbody.substring(17,18);
        idcardbody=idcardbody.substring(0,17);
        var len=idcardbody.length;
        if (len != 17) {
            return false;
        }
        //加权因子
        let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验码对应值
        let code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let checksum = 0;
    
        for (let i = 0; i < len; i++) {
            checksum += idcardbody.substr(i,1) * factor[i];
        }
        //最后一位数
        if(result.toUpperCase() == code[checksum % 11]){
            return true;
        }else{
            return false;
        }
}
 
}

export default new common()